import {useNavigate} from "react-router-dom";

import {SectionCardHeaderAction, SectionField} from "base/component/presentational";

import Grid from "@mui/material/Grid";
import EditIcon from "@mui/icons-material/Edit";
import {NumberUtil} from "base/utilities";
import {SisbagalSectionCard} from "sisbagal/auth";

const SistemaCaracteristicasSection = ({sistema}) => {
    const navigate = useNavigate();

    const secondaryActions = [
        <SectionCardHeaderAction
            key="edit"
            name="edit"
            text="Modificar"
            icon={<EditIcon />}
            onClick={() => {
                navigate(`caracteristicas/edit`);
            }}
            roles={[]}
        />,
    ];

    return (
        <SisbagalSectionCard
            title="Características"
            secondaryActions={secondaryActions}
        >
            <Grid container>
                <Grid item xs={12} lg={6}>
                    <SectionField
                        label="Rexistrado en AdG:"
                        value={sistema.rexistrado_label}
                    />
                    <SectionField
                        label="Número de expediente:"
                        value={sistema.expediente}
                    />
                </Grid>
                <Grid item xs={12} lg={6}>
                    <SectionField
                        label="Porcentaxe de conexión:"
                        value={NumberUtil.formatDecimal(sistema.porcentaxe_conexion)}
                        unit="%"
                    />
                    <SectionField label="Notas:" value={sistema.notas} />
                </Grid>
            </Grid>
        </SisbagalSectionCard>
    );
};

export default SistemaCaracteristicasSection;
